module.exports = __webpack_public_path__ + "static/carousel-hero-lite-6a27b13e50c787d415cd50e86a789548.png";